import React from 'react'

interface IProps {
    value: number
}

function putZero(val: number) {
    const str_val = val.toFixed()
    return '00'.slice(0, 2 - str_val.length) + str_val
}

export function VideoTime({ value }: IProps) {
    const minutes = putZero((value || 0) / 60)
    const seconds = putZero((value || 0) % 60)
    return (
        <span>
            <span>{minutes}</span>:<span>{seconds}</span>
        </span>
    );
}
